















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Page } from "yellowfin-ui-lib";
import { Libro } from "@/data/models/biblioteca.model";

@Component({})
export default class BibliotecaTable extends Vue {
  @Prop() data!: Libro[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;
  @Prop() bibliotecabase!: string;
  @Prop({ default: false }) inlineDetail!: boolean;

  base = "";
  firstload = true;

  @Watch("data")
  onDataChange() {
    this.firstload = false;
  }

  onPageChange(page: number) {
    this.$emit("page", page);
  }

  onSelect(libro: Libro) {
    this.$emit("select", libro);
  }

  mounted() {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const patha = location.pathname;
    let path =
      this.bibliotecabase != undefined && this.bibliotecabase != ""
        ? this.bibliotecabase
        : patha;

    if (path.startsWith("/")) {
      path = path.substring(1);
    }

    if (params && (!this.bibliotecabase || this.bibliotecabase == "")) {
      this.base = "/" + path + "?" + uri + "&profileid=";
    } else {
      this.base = "/" + path + "?profileid=";
    }
  }
}
